import React, { useState, useEffect } from "react";
import { Container } from "reactstrap";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Header from "./Header/HeaderContainer";
import Sidebar from "./Sidebar/Sidebar";
import { signOut } from "./../../actions/auth";
import { getAuth } from "./../../reducers/selectors";
import MediaQuery from "react-responsive";
import { Footer } from "./Footer/Footer";
import { Toaster } from "../Toaster/Toaster";

const MainLayout = (props) => {
  const { actions } = props;
  return (
    <div className="app">
      <Toaster />
      <div className="app-body">
        <Sidebar {...props} />
        <main className="main">
          {/* <Header actions={actions} /> */}
          <Container fluid>{props.children}</Container>
        </main>
        <MediaQuery minWidth={576}>{/* <Footer /> */}</MediaQuery>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  const auth = getAuth(state);
  return {
    auth,
  };
};

const mapDispatchToProps = (dispatch, props) => {
  let actions = {
    auth: bindActionCreators(
      {
        signOut,
      },
      dispatch
    ),
  };

  return { actions, dispatch };
};

export default connect(mapStateToProps, mapDispatchToProps)(MainLayout);
